import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import React from "react";
import Tab from "./Tab";
var Tabs = function(param) {
    var items = param.items, onTabClick = param.onTabClick, activeItem = param.activeItem, className = param.className;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("flex bg-disabled hover:bg-disabled rounded-xl", className),
        children: items.map(function(item) {
            return /*#__PURE__*/ _jsx(Tab, {
                item: item,
                active: activeItem.value === item.value,
                onTabClick: onTabClick
            }, "tab_".concat(item.value));
        })
    });
};
export default Tabs;
